//格式化日期 **********=> 2020年3月23 - 2020年3月29日
export const formatDate = (date, type) => {

  let now = date ? new Date(date) : new Date()
  let week = ["日", "一", "二", "三", "四", "五", "六"]

  let myyear = now.getFullYear()
  let mymonth = (now.getMonth() + 1).toString().padStart(2, "0")
  let myday = now.getDate().toString().padStart(2, "0")
  let myweekday = week[now.getDay()]

  let val
  if (type == 1) val = myyear + "年" + mymonth + "月" + myday + "日" + "(星期" + myweekday + ")"
  else if (type == 2) val = myyear + "年" + mymonth + "月" + myday + "日"
  else if (type == 3) val = myyear + "-" + mymonth + "-" + myday
  else if (type == 4) val = myweekday
  else if (type == 5) val = myyear + "-" + mymonth
  return val
}

// 获得某一周的开始日期
export const getWeekStartDate = (date, type) => {

  let now = new Date(date);
  let timestamp = Date.parse(now);  //时间戳
  let nowDayOfWeek = now.getDay(); // 本周的第几天
  // let nowDay = now.getDate(); // 当前日
  // let nowMonth = now.getMonth(); // 当前月
  // let nowYear = now.getFullYear(); // 当前年

  // let weekStartDate = nowDayOfWeek == 0 ? new Date(nowYear, nowMonth, nowDay - 6) : new Date(nowYear, nowMonth, nowDay - nowDayOfWeek + 1)
  let weekStartDate = nowDayOfWeek == 0 ? timestamp - 6 * 24 * 60 * 60 * 1000 : timestamp - (nowDayOfWeek - 1) * 24 * 60 * 60 * 1000
  let val = formatDate(weekStartDate, type)
  return val
}

// 获得某一周的结束日期
export const getWeekEndDate = (date, type) => {
  let now = new Date(date);
  let timestamp = Date.parse(now);  //时间戳
  let nowDayOfWeek = now.getDay(); // 本周的第几天
  let weekEndDate = nowDayOfWeek == 0 ? timestamp : timestamp + (7 - nowDayOfWeek) * 24 * 60 * 60 * 1000
  let val
  val = formatDate(weekEndDate, type)
  return val
}
/* 获得某一周的开始和结束日期    
** type 1 xxxxxxxxxx=> 2020年1月10日 ( 星期日 ) ~ 2020年1月17日 ( 星期六 )
*/
export const getWeekStartAndEndDate = (date, type) => {
  let now;
  if (date) now = new Date(date); //日期
  else now = new Date();  //日期
  // let nowDayOfWeek = now.getDay(); // 本周的第几天
  // let nowDay = now.getDate(); // 当前日
  // let nowMonth = now.getMonth(); // 当前月
  // let nowYear = now.getFullYear(); // 当前年
  // if (type == "1") return getWeekStartDate(now, "1")
  if (type == 1) return getWeekStartDate(now, type) + ' ~ ' + getWeekEndDate(now, type)
  else if (type == 3) return getWeekStartDate(now, type) + ',' + getWeekEndDate(now, type)
}

//获取年月日周
export const getYearMonthDay = (date) => {
  if (date) {
    var d = new Date(date)
  } else {
    var d = new Date()
  }
  let week = ["日", "一", "二", "三", "四", "五", "六"]
  let year = d.getFullYear() // 年
  let month = (d.getMonth() + 1).toString().padStart(2, "0") // 月
  let day = d
    .getDate()
    .toString()
    .padStart(2, "0") // 日
  let zhouZ = week[d.getDay()] //周 大写
  let zhouN = d.getDay() //周 数字 0周日--6周六
  return { year, month, day, zhouZ, zhouN }
}

//获取最近7天
export const getSevenDay = (date) => {
  if (date) {
    var d = new Date(date)
  } else {
    var d = new Date()
  }
  let timestamp = Date.parse(d);  //时间戳
  let list = []
  // let year = d.getFullYear() // 年
  // let month = (d.getMonth() + 1).toString().padStart(2, "0") // 月
  // let day = d.getDate().toString().padStart(2, "0") // 日
  for (let i = 0; i < 7; i++) {
    list.push(formatDate(timestamp + i * 24 * 60 * 60 * 1000, 2))
  }
  return list
}

export const testM = function (data) {
  // if (data) {
  //   var a = 0.1
  //   var b = 0.2

  // }
  // // let c = null
  // // console.log(Boolean(c))
  // if (a + b == 0.3) { // 别这么干！
  //   // console.log("You got 0.3."); 
  // }
  // let a = 6; let b = 9;
  // function simpleTag(strings, aValExpression, bValExpression, sumExpression) {
  //   console.log(strings);
  //   console.log(aValExpression);
  //   console.log(bValExpression);
  //   console.log(sumExpression); return 'foobar';
  // }
  // let untaggedResult = `${a} + ${b} = ${a + b}`;
  // let taggedResult = simpleTag`${a} + ${b} = ${a + b}`; // ["", " + ", " = ", ""]
  // console.log(untaggedResult);
  // console.log(taggedResult);
  // let result = 15 && 7;
  // console.log(typeof (['1', '2']));
  function setName(obj) {
    obj.name = "Nicholas";
    obj = new Object();
    obj.name = "Greg";
    console.log(obj.name);
  }
  let person = new Object();
  setName(person);
  console.log(person.name);
}
